import {utils} from './common/core';
import {sxhr, sxhrHeaders, sxhrRequest} from 'fire-wind-water/sxhr';
import { ck } from 'fire-wind-water';
import domain from './domain';

sxhrHeaders('Content-Type', 'text/plain');
sxhrRequest((config) => {
  return config;
});

var smkmoduleIds = {
  bigScreen: 3,
  seminar: 3,
  webinar: 2,
  memberForm: 11,
  customForm: 7,
  question: 8,
  poll: 10,
  luckyDraw: 9,
  topic: 24,
  fileFolder: 12,
  file: 12,
  articleCategory: 26,
  article: 26,
  scms: 36,
};
export class Data {
  constructor(url) {
    this.url = url;
  }

  JsonParamsCallback() {
  }

  setDataUrl(url) {
    this.url = url;
  }

  ajax(json) {
    'use strict';
    var settings = {   //默认参数
      url: '',        //请求的URL
      data: ''       //请求的数据
    };
    utils.extend(settings, json);
    return sxhr.post(settings.url, settings.data);
  }

  getJsonParams(info) {
    var o = {
      _cache_refresh: 0,
      _cache_timeout: 300,
      _cache_with_cached: 1
    };
    utils.extend(info, o);
    this.ajax({
      url: this.url + '/api/common/jsonParams/get',
      data: info
    }).then((res) => {
      var data = res.data.body;
      //来源管理获取最早的实例参数，保存到cookie里，提交时加入browseInfo
      //console.log('getJsonParams data', data);
      this.saveSourceData(data.content);
      //this.savePreData(data);
      this.JsonParamsCallback(data);
    });
  }
  removeChannelCookie() {
    var channelList = ck.cookie();
    // 循环遍历对象的属性
    for (var val in channelList) {
      // eslint-disable-next-line no-prototype-builtins
      if (
          channelList[val] &&
          val.indexOf('channel_') !== -1) {
        ck.removeCookie(val, {path: '/', domain: domain.getDomain('')});
      }
    }
  }

  saveSourceData(info) {
    var fields = {
      'firstTenantId': 'tenantId',
      'firstModuleId': 'moduleId',
      'firstInstanceId': 'instanceId',
      'firstObjModuleId': 'objModuleId',
      'firstObjId': 'objId',
      'firstProgramId': 'programId',
      'firstTrack': 'track'
    };
    //如果是一个租户下的cookie，记录的首次来源是正确的，如果是新的租户，需要清空，重新记录
    var tenantId = ck.cookie('channel_firstTenantId') || null;
    if (!tenantId || tenantId !== info.tenantId) {
      this.removeChannelCookie();
    }
    var objId = ck.cookie('channel_firstObjId') || null;
    if ((objId && objId !== 0 && objId !== null) || (!info.objId || info.objId === '0')) {
      return false;
    }
    //如果是注册表单，带backUrl时，说明从某实例跳来的注册，需要记跳来的实例
    var wurl = window.location.href;
    if (info.moduleId === 11 && wurl.indexOf('backUrl=') !== -1){
      return false;
    }
    //console.log('saveSourceData0_val', info);
    if (info.type === 'instance') {
      info.objModuleId = info.moduleId;
    } else {
      info.objModuleId = smkmoduleIds[info.type];
    }
    if (info.module){
      info.moduleId = info.module;
    }
    //首次进入加是否是渠道来的标识
    info.track = (wurl.indexOf('track_id') !== -1 || wurl.indexOf('markCode') !== -1) ? 1 : 0;
    info.programId = info.programId || '';
    info.objectTitle = '';
    //console.log('saveSourceData info', info);
    //console.log('saveSourceData domain', domain.getDomain(''));
    for (var val in fields) {
      var temp = fields[val];
      ck.cookie('channel_' + val, info[temp], {
        domain: domain.getDomain(''),
        path: '/'
      });
    }
    return true;
  }

  //记录注册表单前一次访问的实例信息
  savePreData(info) {
    var paramList = {
      'skModuleId': 'moduleId',
      'skInstanceId': 'instanceId',
      'skObjId': 'objId'
    };
    if (info.type !== 'instance') {
      info.moduleId = smkmoduleIds[info.type];
    }
    if (info.moduleId === 11 || !info.objId || info.objId === '0') {
      return false;
    }
    for (var va in paramList) {
      var temp = paramList[va];
      ck.cookie('channel_' + va, info[temp], {
        domain: domain.getDomain(''),
        path: '/',
        expires: 5 / 60,
      });
    }
    return true;
  }

}
